import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { paymentRequestService } from "../services/payment-request";

const paymentRequestKeys = {
  all: ["paymentRequest"] as const,
  data: (dbName: string) =>
    [...paymentRequestKeys.all, "data", dbName] as const,
};

export function usePaymentRequestData(dbName: string | null) {
  return useQuery({
    queryKey: paymentRequestKeys.data(dbName || ""),
    queryFn: async () => {
      if (!dbName) return null;
      const response =
        await paymentRequestService.getPaymentRequestData(dbName);
      return response.data;
    },
    enabled: !!dbName,
    staleTime: 30000,
    refetchInterval: false,
  });
}

export function useRequestPaymentMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      dbName,
      ops,
      dateToCheckout,
    }: {
      dbName: string;
      ops: string;
      dateToCheckout: string;
    }) => {
      const response = await paymentRequestService.requestPayment(
        dbName,
        ops,
        dateToCheckout
      );
      return response.data;
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: paymentRequestKeys.data(variables.dbName),
      });
    },
  });
}

export function useInvalidatePaymentRequest() {
  const queryClient = useQueryClient();

  return (dbName: string) => {
    queryClient.invalidateQueries({
      queryKey: paymentRequestKeys.data(dbName),
    });
  };
}
